<template>
  <div>
    <vue-progress-bar></vue-progress-bar>
    <div id="lhs_wrapper">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
    <div id="store-links" v-if="project.logo">
      <img class="logo-img" :src="hostAddress + project.logo" alt="" />
      <a v-if="project.cityapp" :href="project.cityapp.play_store_url" target="_blank">
        <i class="material-icons-round">android</i>
      </a>
      <a v-if="project.cityapp" :href="project.cityapp.app_store_url" target="_blank">
        <img src="../assets/icons/apple.png" alt="apple" />
      </a>
    </div>
    <div id="bottom-bar">
      <div id="company-links">
        <a href="https://www.schubert-franzke.com" target="_blank" >
          <img class="company-logo" src="../assets/icons/sf_logo.png" alt="" />
        </a>
        <ImprintLinks />
      </div>
      <div id="scale-bar"></div>
      <div id="imprint"></div>
    </div>

    <SettingButtonsComponent 
    @openWeatherMTK="openWeatherMTK" 
    @forceCloseWeather="handleToggleWeather"  
    :isWeatherActive="showWeatherMtk"/>

    <PrintOverlay v-if="$root.$data.printMode" />

    <div id="hover-popup"></div>
    <ul id="cluster-popup"></ul>
    <div id="map" @contextmenu.prevent="$refs.menu.open" @contextmenu="setCoordinates($event)"></div>
    <vue-context ref="menu" v-if="!$root.$data.embedded" :close-on-click="false" :lazy="true">
      <div class="coords">
        <p>{{ this.googleCoords }}</p>
        <i class="material-icons-round copy" @click.prevent="copyCoordinates">copy</i>
      </div>
      <li @click.prevent="setStartpoint">
        <img src="../assets/icons/marker.png" alt="" />
        <a>{{ $t("rightClickFrame.startPoint") }}</a>
      </li>
      <li @click.prevent="setEndpoint">
        <img src="../assets/icons/marker.png" alt="" />
        <a>{{ $t("rightClickFrame.endPoint") }}</a>
      </li>
      <li @click.prevent="getNearestPoi">
        <img src="../assets/icons/location.png" alt="" />
        <a>{{ $t("rightClickFrame.whatIsHere") }}</a>
      </li>
      <li @click.prevent="togglePrintMode">
        <img src="../assets/icons/print.png" alt="" />
        <a>{{ $t("rightClickFrame.print") }}</a>
      </li>
      <li @click.prevent="goToMeasure">
        <img src="../assets/icons/ruler-pencil.png" alt="" />
        <a>{{ $t("rightClickFrame.measure") }}</a>
      </li>
    </vue-context>
    <WeatherMTK
      ref="weatherMtk"
      v-if="showWeatherMtk"
      :lat="weatherLat"
      :lng="weatherLng"
      :zoom="weatherZoom"
      :visible="showWeatherMtk"
      @locationChanged="onWeatherMapMoved" 
      @close="closeWeatherMTK"
    >
      <template #controls>
        <SettingButtonsComponent 
        @openWeatherMTK="openWeatherMTK" 
        @forceCloseWeather="handleToggleWeather" 
        :isWeatherActive="showWeatherMtk"/>
      </template>
    </WeatherMTK>
  </div>
</template>

<script>
import Vue from "vue";
import VueContext from "vue-context";
import "vue-context/src/sass/vue-context.scss";
import {basemap} from "@/services/map/basemap";
import SettingButtonsComponent from "./button_controls/SettingButtons";
import M2wApi from "@/services/m2w_api";
import PrintOverlay from "@/components/PrintOverlay";
import {googleMaps} from "@/services/map/googleMaps";
import ImprintLinks from "@/components/page_elements/ImprintLinks";
import ZIndex from "@/services/zindex";
import Clipboard from "@/services/clipboard";
import WeatherMTK from "@/components/WeatherMTK.vue";

export default {
  name: "MapComponent",
  components: {ImprintLinks, PrintOverlay, VueContext, SettingButtonsComponent,WeatherMTK},
  data() {
    return {
      map: {},
      coordinates: null,
      category: {},
      hostAddress: M2wApi.host_address,
      project: Vue.config.project,
      showWeatherMtk: false,
      weatherLat: 45.75,
      weatherLng: 21.23,
      weatherZoom: 15,
    };
  },
  computed: {
    googleCoords() {
      return this.coordinates ? googleMaps.toGoogleCoordinateString(this.coordinates) : null;
    }
  },
    async mounted() {
    window.addEventListener("message", this.receiveMessageFromWeatherMap);
    await basemap.initMap(this.$route.query.lid);
    this.setupBasemapLayer();
    if (this.$route.path === "/" && Vue.config.project.default_view !== "/") {
      await this.$router.push(Vue.config.project.default_view);
    }
    this.fetchLocationUrl();
    window.addEventListener("popstate", this.fetchLocationUrl);
    basemap.map.on("moveend", this.updatePermalink);

  },

  methods: {

    async setupBasemapLayer() {
      const cfg = Vue.config.project.sf_basemap;
      if (!cfg) return;
      try {
        let layer;
        switch (cfg.type) {
          case "wmts":
            layer = await basemap.getWmtsLayer(cfg);
            break;
          case "wms":
            layer = await basemap.getWmsLayer(cfg);
            break;
          case "xyz":
            layer = await basemap.getXyzLayer(cfg);
            break;
        }
        if (layer) {
          layer.setZIndex(ZIndex.SFMap);
          Vue.config.project.sf_basemap.layer = layer;
          basemap.map.addLayer(layer);
        }
      } catch (e) {
        console.error("Eroare la adăugarea stratului de bază:", e);
      }
    },

    updatePermalink() {
      if (!this.shouldUpdate) {
        this.shouldUpdate = true;
        return;
      }
      const view = basemap.map.getView();
      const [x, y] = view.getCenter();
      const zoom = view.getZoom();
      const serialized = `${Math.round(x)},${Math.round(y)},${zoom}`;
      if (this.$route.query.location !== serialized) {
        this.$router.replace({ query: { ...this.$route.query, location: serialized } });
      }
    },
    fetchLocationUrl() {
      const location = this.$route.query.location;
      if (!location) return;
      const match = location.match(/^([-0-9.]+),([-0-9.]+),([0-9.]+)$/);
      if (!match) return;
      const [_, x, y, zoom] = match.map(Number);
      const view = basemap.map.getView();
      view.setCenter([x, y]);
      view.setZoom(zoom);
      if (Vue.config.project.sf_basemap && !isNaN(this.$route.query.sflo)) {
        const opacity = parseInt(this.$route.query.sflo, 10);
        if (opacity >= 0 && opacity <= 100) {
          Vue.config.project.sf_basemap.layer.setOpacity(opacity / 100);
        }
      }
    },

    setCoordinates(event) {
      this.coordinates = basemap.map.getEventCoordinate(event);
    },

    async copyCoordinates() {
      await Clipboard.copy(this.googleCoords);
    },
    async getNearestPoi() {
      const poi = await M2wApi.get_closest_poi(this.coordinates, this.$i18n.locale);
      if (poi.obj) {
        await this.$router.push({ name: "poiDetails", params: { id: poi.obj }, query: this.$route.query });
      } else if (poi.address) {
        await this.$router.push({
          name: "pois",
          params: { view: "streets" },
          query: { ...this.$route.query, str_id: poi.address.id, hnr: poi.address.house_number.hnr }
        });
      }
      this.$refs.menu.close();
    },

    togglePrintMode() {
      this.$root.$data.printMode = !this.$root.$data.printMode;
      this.$refs.menu.close();
    },

    goToMeasure() {
      this.$router.push({name: "measure"});
      this.$refs.menu.close();
    },

    setStartpoint() {
      this.$router.push({name: "directions", query: {...this.$route.query, from: this.googleCoords}});
      this.$refs.menu.close();
    },

    setEndpoint() {
      this.$router.push({name: "directions", query: {...this.$route.query, to: this.googleCoords}});
      this.$refs.menu.close();
    },

     openWeatherMTK() {
      const view = basemap.map.getView();
      const center = googleMaps.transformToLatLngLiteral(view.getCenter());
      const zoom = view.getZoom();
      // const zoom = Vue.config.project?.default_zoom ?? 12;
      Object.assign(this, { weatherLat: center.lat, weatherLng: center.lng, weatherZoom: zoom });
      this.showWeatherMtk = true;
    },
    onWeatherMapMoved({ lat, lon, zoom }) {
      console.log("[MapComponent] Location from weather map:", lat, lon, zoom);
      Object.assign(this, { weatherLat: lat, weatherLng: lon, weatherZoom: zoom });
    },
    closeWeatherMTK() {
      const view = basemap.map?.getView?.();
      if (!view) return console.warn("There is no active view on the map.");
      const center = googleMaps.transformFromLatLng({ lat: this.weatherLat, lng: this.weatherLng });
      view.setCenter(center);
      view.setZoom(this.weatherZoom);
      this.showWeatherMtk = false;
    },
    handleToggleWeather() {
      if (this.showWeatherMtk) {
        this.closeWeatherMTK(); // close map weather if it's on
      }
    }
  }
};
</script>
